import * as TYPES from './lookups-actiontypes';

export const initialState = {
  relationships: [],
  preferredCommunications: [],
  countries: [],
  states: [],
  ssoEnabledFlag: false,
};

export const lookupsReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TYPES.LOOKUPS_LOADRELATIONSHIPS_SUCCESS: {
      newState = { ...state, relationships: action.relationships };
      break;
    }
    case TYPES.LOOKUPS_LOADPREFERREDCOMMUNICATIONS_SUCCESS: {
      newState = { ...state, preferredCommunications: action.preferredCommunications };
      break;
    }
    case TYPES.LOOKUPS_LOADCOUNTRIES_SUCCESS: {
      newState = { ...state, countries: action.countries };
      break;
    }
    case TYPES.LOOKUPS_LOADSTATES_SUCCESS: {
      newState = { ...state, states: action.states };
      break;
    }
    default:
      newState = state;
      break;
  }

  return newState;
};

export default lookupsReducer;
